import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, AfterViewInit, ViewEncapsulation, HostListener } from '@angular/core';

import { MapsAPILoader } from '@agm/core';

import { WindowRef } from '@shared/services';

window['fbAsyncInit'] = function() {
  Parse.FacebookUtils.init({ // this line replaces FB.init({
    appId      : '178601089344748', // Facebook App ID
    cookie     : true,  // enable cookies to allow Parse to access the session
    xfbml      : true,  // initialize Facebook social plugins on the page
    version    : 'v2.10' // point to the latest Facebook Graph API version
  });
};

// const SERVER_URL = 'http://localhost/1';
// const SERVER_URL = 'http://sfl.coolbeans.studio/1';

// const SERVER_URL = 'https://swiftfreightlogistics.com/1';

// const DEV = window.location.hostname !== 'swiftfreightlogistics.com';
// const SERVER_URL = DEV ? 'https://139.59.98.46/1' : 'https://swiftfreightlogistics.com/1';

let origin = window.location.origin;

if (!origin) {
  origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

let isDev = (window.location.hostname === 'localhost');

const localhostServerUrl = 'http://localhost/1';

const SERVER_URL = isDev ? localhostServerUrl : origin + '/1';

const APPLICATION_ID = 'iLUH4yjtIjUGyEIXsx2bu9NKoEsS5NjNPFMYojMe';
const JAVASCRIPT_KEY = 'pVYhevk1iylw1gqDzpBynanEsGXKMoE6N5PSjoNj';
const FILE_KEY = 'wzys1fi14evd2bx2pkydch91aq7fxx';

@Component({
  moduleId: 'module.id',
  selector: 'app',
  styles: [require('./app.component.scss')],
  template: require('./app.component.html'),
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private router: Router,
    private windowRef: WindowRef,
    private mapsAPILoader: MapsAPILoader) {

    Parse.serverURL = SERVER_URL;
    Parse.initialize(APPLICATION_ID, JAVASCRIPT_KEY);

    window['fbAsyncInit']();

    this.mapsAPILoader.load();
  }

  public ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      console.log(this.windowRef.content);

      if (this.windowRef.content) {
        this.windowRef.content.scrollTop = 0;
      } else {
        window.scroll(0, 0);
      }
    });
  }

  public ngAfterViewInit() {
    this.checkWidth(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event) {
    this.checkWidth(event.target.innerWidth);
  }

  private checkWidth(width: number) {
    this.windowRef.isLarge = width > WindowRef.LARGE_WIDTH;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.component.ts